import React from 'react'
import { makeStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'
import toFarsiNumber from 'src/utils/toFarsiNumbers'
import { useSelector } from 'react-redux'
import { selectorExamQuestionsErr } from 'src/app/slices/examSlice'
import Options from './Options'

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '50px calc(50% - 25px - 5px) calc(50% - 25px - 5px)',
    '@media (max-width: 960px)': {
      gridTemplateColumns: '50px 1fr',
      margin: '20px 0',
    },
    gridGap: 5,
    '&:hover> *': {
      backgroundColor: '#0000000f',
      cursor: 'default',
    },
  },
  indexTitle: {
    textAlign: 'center',
    '@media (max-width: 960px)': {
      borderRadius: '10px',
      margin: '10px auto',
      borderTop: '1px solid #d8d8d8',
      display: 'flex',
      alignItems: 'center',
    },
  },
  frame: {
    padding: '8px 10px',
    '@media (max-width: 960px)': {
      padding: '8px 14px',
    },
  },
  title: {
    flex: 1,
    '@media (max-width: 960px)': {
      borderRadius: '10px',
      margin: '10px 0',
      borderTop: '1px solid #d8d8d8',
    },
  },
  text: {
    fontWeight: 600,
    userSelect: 'none',
  },
  row: {
    '& > *': {
      borderBottom: '1px solid #d8d8d8',
      borderLeft: '1px solid #d8d8d8',
      borderRight: '1px solid #d8d8d8',
    },
  },
  top: {
    marginTop: 10,
    '& > *': {
      borderTop: '1px solid #d8d8d8',
      borderRadius: '10px 10px 0 0 ',
      '@media (max-width: 960px)': {
        borderRadius: '10px',
      },
    },
  },
  bottom: {
    '& > *': {
      borderRadius: '0 0 10px 10px',
      '@media (max-width: 960px)': {
        borderRadius: '10px',
      },
    },
    marginBottom: 20,
  },
  frame2: {
    backgroundColor: '#dff5fe',
    padding: '8px 10px',
    borderRadius: 10,
  },
  options: {
    display: 'flex',
    padding: '0',
    '& > div': {
      padding: '8px 0',
      userSelect: 'none',
      flex: 1,
      borderRight: '1px solid white',
      textAlign: 'center',
      fontWeight: 500,
      fontSize: 14,
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '@media (max-width: 960px)': {
      gridColumnEnd: 'span 2',
      border: 'none',
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      margin: '-6px 0',
    },
  },
}))

export default function Question({
  data, rowIndex, top, bottom, options, ...res
}) {
  const classes = useStyles()
  const ans = useSelector((state) => state.exam.selectedExam.answers)
  const finishedResponse = useSelector(selectorExamQuestionsErr)

  const answeredQ = ans?.find((a) => +a?.question?.id === +data?.id)

  return (
    <div
      className={
        classNames(classes.root, classes.row, {
          [classes.top]: top,
          [classes.bottom]: bottom,
        })
      }
    >
      <div className={classNames(classes.indexTitle, classes.frame)}>
        <Typography className={classes.text} variant="body2">{toFarsiNumber(rowIndex)}</Typography>
      </div>
      <div className={classNames(classes.title, classes.frame)}>
        <Typography
          style={{
            color: (!answeredQ
          && finishedResponse) && 'red',
          }}
          className={classes.text}
          variant="body2"
        >
          {data.question}

        </Typography>
      </div>

      {window.outerWidth < 960 && (
      <div className={classNames(classes.options, classes.frame2)}>
        {options?.map((option) => (
          <div key={option.id}>{option.title}</div>
        ))}
      </div>
      )}

      <Options question={data} {...res} />
    </div>
  )
}
